import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import type { BrandConfigDetail } from '@/pleased-sdk/PleasedApi/models.pleased';
import { PleasedApi } from '@/pleased-sdk';
import { isSkipToLiveAgentActive as resolveSkipToLiveAgentActive } from '@/common/skipToLiveAgent.utils';

export const useBrandConfig = defineStore('brandConfig', () => {
  const brandConfig = ref<BrandConfigDetail | null>(null);
  const loading = ref(false);
  const error = ref<Error | null>(null);

  const isSkipToLiveAgentActive = computed(() => resolveSkipToLiveAgentActive(brandConfig.value));

  let inFlight: Promise<BrandConfigDetail> | null = null;

  async function fetchBrandConfig(): Promise<BrandConfigDetail> {
    if (brandConfig.value) return brandConfig.value;
    if (inFlight) return inFlight;

    loading.value = true;
    inFlight = PleasedApi.getBrandConfig()
      .then(({ data }) => {
        brandConfig.value = data;
        return brandConfig.value;
      })
      .catch((err) => {
        error.value = err as Error;
        throw err;
      })
      .finally(() => {
        loading.value = false;
        inFlight = null;
      });

    return inFlight;
  }

  return { brandConfig, loading, error, fetchBrandConfig, isSkipToLiveAgentActive };
});
